import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatRupiah } from "@/lib/api";

export const CartPanel = ({ cart, total, onQty, onRemove, onClear, onCheckout }) => (
  <div className="flex h-full flex-col" data-testid="cart-panel">
    <div className="flex items-center justify-between border-b border-slate-100 pb-3">
      <h3 className="font-display text-lg font-semibold text-slate-800">Keranjang</h3>
      {cart.length > 0 && (
        <button onClick={onClear} className="text-xs font-semibold text-red-600 hover:underline" data-testid="cart-clear-button">Kosongkan</button>
      )}
    </div>
    <div className="flex-1 overflow-y-auto py-2">
      {cart.length === 0 ? (
        <div className="flex flex-col items-center py-12 text-slate-400" data-testid="cart-empty">
          <ShoppingBag className="h-10 w-10" />
          <p className="mt-2 text-sm">Belum ada item</p>
        </div>
      ) : (
        cart.map((c) => (
          <div key={c.key} className="flex items-center gap-2 border-b border-slate-50 py-3" data-testid={`cart-item-${c.key}`}>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-slate-800">{c.name}</p>
              {c.label && <p className="truncate text-xs text-emerald-700" data-testid={`cart-item-options-${c.key}`}>{c.label}</p>}
              <p className="font-mono text-xs text-slate-500">{formatRupiah(c.price)}</p>
            </div>
            <div className="flex items-center gap-1">
              <Button size="icon" variant="outline" className="h-7 w-7" onClick={() => onQty(c.key, -1)} data-testid={`cart-qty-decrease-${c.key}`}><Minus className="h-3 w-3" /></Button>
              <span className="w-7 text-center font-mono text-sm font-bold" data-testid={`cart-qty-${c.key}`}>{c.qty}</span>
              <Button size="icon" variant="outline" className="h-7 w-7" onClick={() => onQty(c.key, 1)} data-testid={`cart-qty-increase-${c.key}`}><Plus className="h-3 w-3" /></Button>
            </div>
            <button onClick={() => onRemove(c.key)} className="p-1 text-slate-400 hover:text-red-600" data-testid={`cart-remove-${c.key}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))
      )}
    </div>
    <div className="space-y-3 border-t border-slate-100 pt-4">
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-500">{cart.reduce((s, c) => s + c.qty, 0)} item</span>
        <span className="font-mono text-2xl font-bold text-slate-900" data-testid="cart-total">{formatRupiah(total)}</span>
      </div>
      <Button disabled={!cart.length} onClick={onCheckout} className="h-12 w-full bg-emerald-600 text-base hover:bg-emerald-700" data-testid="cart-checkout-button">
        Bayar
      </Button>
    </div>
  </div>
);
